import { withInstall } from '../../utils/install'
import index from './src/index.vue'

export const ZnTest = withInstall(index) // 增加类型

export default ZnTest
